<template>
  <v-card-title 
    class="pa-0 headline black--text font-weight-medium justify-center"
  >
    <v-row class="px-0 py-2">
      <v-col cols="1" class="pa-0"></v-col>
      <v-col cols="10" class="pa-0">
        <span>
          <!-- TITLE -->
          <slot name='title'></slot>
        </span>
      </v-col>
      <v-col cols="1" class="pa-0">
        <v-tooltip
          :open-delay="tooltipDelay"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <span>
              <v-icon
                color="grey"
                class="mr-1 mt-1 tooltip-top-right"
                dark
                left
                v-bind="attrs"
                v-on="on"
              >mdi-information-outline</v-icon>
            </span>
          </template>
          <span>
            <!-- Tooltip -->
            <slot name='tooltip'></slot>
          </span>
        </v-tooltip>

      </v-col>
    </v-row>
  </v-card-title>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .tooltip-top-right {
    opacity: 0.5;
    position:absolute;
    top:0;
    right:0;
  }
</style>